// Module
var code = `<section class="page-body default-content">
  <h2>Cards</h2>
  <p>
    Cards are self-contained content blocks designed to display images, titles,
    metadata, and optional call-to-action (CTA) text. Use them inside a
    <code>.card-list</code> grid for responsive layout.
  </p>

  <div class="docs-example">
    <ul class="cards-container card-list" aria-label="cards">

      <!-- ===================================================== -->
      <!-- 1. BASIC CARD -->
      <!-- ===================================================== -->
      <li class="card">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x200"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Basic Card</h2>
            <p class="card__meta">
              The default card layout with image, title, body text, and CTA.
            </p>
            <p class="card__meta card__meta__cta">Read More</p>
          </div>
        </a>
      </li>

      <!-- ===================================================== -->
      <!-- 2. CARD WITH CTA BUTTON -->
      <!-- ===================================================== -->
      <li class="card">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x200"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Card with Button CTA</h2>
            <p class="card__meta">
              Use a button when the action is primary.
            </p>
            <button class="btn btn-primary card__cta">
              Get Started
            </button>
          </div>
        </a>
      </li>

      <!-- ===================================================== -->
      <!-- 3. CARD WITHOUT IMAGE -->
      <!-- ===================================================== -->
      <li class="card card--no-image">
        <a class="page-card" href="#">
          <div class="card__content">
            <h2 class="card__title">Text-Only Card</h2>
            <p class="card__meta">
              Cards do not require images. This works well for documentation
              and dense content lists.
            </p>
            <p class="card__meta card__meta__cta">Read More</p>
          </div>
        </a>
      </li>

      <!-- ===================================================== -->
      <!-- 4. METADATA-HEAVY CARD -->
      <!-- ===================================================== -->
      <li class="card card--meta-heavy">
        <a class="page-card" href="#">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x400"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Metadata Card</h2>

            <ul class="card__meta-list">
              <li><strong>Version:</strong> 1.2.0</li>
              <li><strong>Status:</strong> Stable</li>
              <li><strong>Updated:</strong> Jan 2026</li>
            </ul>

            <p class="card__meta card__meta__cta">View Details</p>
          </div>
        </a>
      </li>

      <!-- ===================================================== -->
      <!-- 5. ICON / SYMBOL CARD -->
      <!-- ===================================================== -->
      <li class="card card--icon">
        <a class="page-card" href="#">
          <div class="card__icon">⚡</div>
          <div class="card__content">
            <h2 class="card__title">Icon Card</h2>
            <p class="card__meta">
              Use icons instead of images for abstract or system-level concepts.
            </p>
          </div>
        </a>
      </li>

      <!-- ===================================================== -->
      <!-- 6. DISABLED / INFORMATIONAL CARD -->
      <!-- ===================================================== -->
      <li class="card card--disabled" aria-disabled="true">
        <div class="page-card">
          <div class="card__image-wrapper">
            <img
              class="card__image"
              src="https://placehold.co/600x200"
              alt="Placeholder image"
            />
          </div>
          <div class="card__content">
            <h2 class="card__title">Coming Soon</h2>
            <p class="card__meta">
              This feature is under active development.
            </p>
          </div>
        </div>
      </li>

    </ul>
  </div>
</section>
`;
// Exports
module.exports = code;